import React from 'react';
import PropTypes from 'prop-types';

export default function IconGeoLocation({ className }) {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.91827 10.8571L6.00053 14.0582L9.08469 10.8548C9.82748 10.0834 10.2955 9.40494 10.5836 8.73445C10.869 8.07007 11 7.36199 11 6.5C11 3.62468 8.77557 1.5 6.00019 1.5C3.22439 1.5 1 3.62472 1 6.5C1 7.39126 1.10205 8.05644 1.36482 8.68659C1.63078 9.32439 2.09199 9.99912 2.91827 10.8571ZM6.00056 15.5L2.19792 11.5507C0.445635 9.73122 0 8.44245 0 6.5C0 3.05851 2.68613 0.5 6.00019 0.5C9.31387 0.5 12 3.05851 12 6.5C12 8.44129 11.4046 9.88717 9.80508 11.5484L6.00056 15.5ZM8.5 6.5C8.5 7.88071 7.38071 9 6 9C4.61929 9 3.5 7.88071 3.5 6.5C3.5 5.11929 4.61929 4 6 4C7.38071 4 8.5 5.11929 8.5 6.5ZM6 8C6.82843 8 7.5 7.32843 7.5 6.5C7.5 5.67157 6.82843 5 6 5C5.17157 5 4.5 5.67157 4.5 6.5C4.5 7.32843 5.17157 8 6 8Z"
        fill="#142138"
      />
    </svg>
  );
}

IconGeoLocation.propTypes = {
  className: PropTypes.string,
};

IconGeoLocation.defaultProps = {
  className: '',
};
